import React from "react";
import TopBar from "./TopBar";

const AboutPage = () => {
  return (
    <>
      <TopBar/>
    <div className="min-h-screen flex flex-col items-center bg-heroBg text-astro">
      {/* Mission Statement */}
      <section className="w-full text-center py-20">
        <h1 className="text-5xl font-bold">About Astro Trader</h1>
        <p className="mt-4 text-lg text-gray-700 max-w-2xl mx-auto">
        Astro Trader is a revolutionary platform that fuses astrological
        insights with real-time market data to give traders a powerful edge. By identifying
        patterns between cosmic movements and financial trends, we help you time your
        trades, manage risk, and spot opportunities others miss
        </p>
      </section>

      {/* Website Overview 
      <section className="mt-10 max-w-4xl">
        <h2 className="text-3xl font-bold text-center">What is Astro Trader?</h2>
        <p className="mt-4 text-lg text-gray-700 text-center">
          Astro Trader is an innovative platform that combines astrological insights with financial market trends to help traders make strategic investment decisions. Our vision is to bridge the gap between cosmic patterns and modern-day finance, providing users with unique data-driven strategies.
        </p>
      </section>*/}

      {/* Contact Section 
      <section className="mt-20 text-center">
        <h2 className="text-3xl font-bold">Contact Us</h2>
        <p className="mt-2 text-gray-700">Have questions? Get in touch with our team.</p>
        <button className="mt-6 px-6 py-3 bg-gold text-[#041c16] rounded-lg shadow-md hover:bg-opacity-90 transition">Contact Support</button>
      </section>*/}
    </div>
    </>
  );
};

export default AboutPage;
